import {helpers, email} from 'vuelidate/lib/validators';

/**
 * Validate whether the value is a placeholder or a valid email
 */
export default helpers.withParams({type: 'placeholderEmail'}, (value) => {
    if (helpers.req(value)) {
        if (email(value)) {
            return true;
        }
        return helpers.regex('placeholderEmail', /^\{{\s*\w[\d\w.]+\w\s*\}}$/)(value);
    }
    return true;
});
